<!--
 * @Description: 平台商户充值
-->
<template>
  <div class="merchant-pay">
    <div class="merchant-pay__toolbar">
      <el-form :inline="true" size="small">
        <el-form-item label="选择商户">
          <el-select
            v-model="selectedMerchantId"
            filterable
            clearable
            placeholder="请选择商户"
            style="width: 280px"
          >
            <el-option
              v-for="item in merchantOptions"
              :key="item.merchantId"
              :label="item.merchantName"
              :value="item.merchantId"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <el-card class="merchant-pay__card" shadow="never">
      <div slot="header" class="merchant-pay__card-title">商户充值</div>
      <el-form
        ref="rechargeForm"
        :model="rechargeForm"
        :rules="rechargeRules"
        label-width="88px"
        size="small"
        class="merchant-pay__form"
      >
        <el-form-item label="充值金额" prop="amount">
          <div class="merchant-pay__amount-field">
            <el-input
              v-model="rechargeForm.amount"
              placeholder="请输入充值金额"
              class="merchant-pay__amount-input"
            >
              <template slot="append">元</template>
            </el-input>
            <div class="merchant-pay__amount-tip">
              支持正负，单位：元，保留两位小数
            </div>
          </div>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="rechargeForm.remark"
            type="textarea"
            :rows="2"
            maxlength="128"
            show-word-limit
            placeholder="请输入备注"
            style="width: 420px"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="rechargeLoading"
            :disabled="!selectedMerchantId"
            @click="handleRecharge"
          >
            提交充值
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { platformMerchantRecharge } from "@/api/business";
import {
  AMOUNT_REG,
  yuanToCents,
  fetchActiveMerchants,
  checkPlatformAdminOrFinance,
} from "./utils";

export default {
  name: "platformMerchantRecharge",
  beforeRouteEnter(to, from, next) {
    if (checkPlatformAdminOrFinance()) {
      next();
    } else {
      next("/404");
    }
  },
  data() {
    const validateAmount = (rule, value, callback) => {
      if (!value && value !== 0) {
        callback(new Error("请输入充值金额"));
        return;
      }
      if (!AMOUNT_REG.test(String(value).trim())) {
        callback(new Error("金额格式不正确，最多保留两位小数"));
        return;
      }
      if (yuanToCents(value) === 0) {
        callback(new Error("充值金额不能为0"));
        return;
      }
      callback();
    };
    return {
      merchantOptions: [],
      selectedMerchantId: "",
      rechargeForm: {
        amount: "",
        remark: "",
      },
      rechargeRules: {
        amount: [{ required: true, validator: validateAmount, trigger: "blur" }],
      },
      rechargeLoading: false,
    };
  },
  created() {
    this.loadMerchants();
  },
  methods: {
    async loadMerchants() {
      try {
        this.merchantOptions = await fetchActiveMerchants();
      } catch (error) {
        console.log(error);
        this.merchantOptions = [];
        this.$message.error("加载商户列表失败");
      }
    },
    async handleRecharge() {
      if (!this.selectedMerchantId) {
        this.$message.warning("请先选择商户");
        return;
      }
      this.$refs.rechargeForm.validate(async (valid) => {
        if (!valid) return;
        try {
          this.rechargeLoading = true;
          await platformMerchantRecharge({
            merchantId: this.selectedMerchantId,
            amount: yuanToCents(this.rechargeForm.amount),
            remark: this.rechargeForm.remark,
          });
          this.$message.success("充值成功");
          this.rechargeForm.amount = "";
          this.rechargeForm.remark = "";
          this.$refs.rechargeForm.clearValidate();
        } catch (error) {
          console.log(error);
        } finally {
          this.rechargeLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.merchant-pay {
  padding: 20px;

  &__toolbar {
    margin-bottom: 16px;
  }

  &__card-title {
    font-weight: 600;
    color: #333;
  }

  &__form {
    max-width: 640px;
  }

  &__amount-field {
    width: 100%;
    max-width: 420px;
  }

  &__amount-input {
    width: 100%;
  }

  &__amount-tip {
    margin-top: 6px;
    font-size: 12px;
    line-height: 1.5;
    color: #909399;
  }
}
</style>
